import React from 'react'
import { Provider } from 'react-redux'
import store from '../store'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import Home from '../pages/home/index'
import BlogHome from '../pages/blog/index'
import BlogPost from '../pages/blog/post'
import TerminosCondiciones from '../pages/institutional/TerminosCondiciones'
import TratamientoDatos from '../pages/institutional/TratamientoDatos'
import Dashboard from '../pages/dashboard/index'
import Page404 from '../pages/404/index'

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/blog" exact component={BlogHome} />
          <Route path="/por-que-hoy-todo-el-mundo-habla-de-emprender" exact component={BlogPost} />
          <Route path="/terminos-condiciones" exact component={TerminosCondiciones} />
          <Route path="/anexo-iii-autorizacion-tratamiento-de-datos-personales-para-emprendores-de-boticario-colombia-s-a-s" exact component={TratamientoDatos} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path='*' exact={true} component={Page404} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
